export const actions = {
    SHOW_LOADING:'SHOW_LOADING',
    SET_ALERT:'SET_ALERT',
    SET_USER:'SET_USER'
};


// WEBPACK FOOTER //
// ./src/actions/actionTypes.js